import React from 'react';
import Index from './components';

const App = () => (
	<Index />
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js